// hooks/useDeleteLora.ts
"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetch } from "libs";
import { DELETE_LORA } from "api";

interface DeleteLoraResponse {
  message: string;
}

const deleteLora = async (loraId: string): Promise<DeleteLoraResponse> => {
  const response = await fetch(`${DELETE_LORA(loraId)}`, {
    method: "DELETE",
  });
  
  return response;
};

const useDeleteLora = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteLora,
    onSuccess: (data) => {
      console.log("Lora deleted successfully", data);
      // Invalidate and refetch the admin loras query to update the UI
      queryClient.invalidateQueries({ queryKey: ['adminLoras'] });
    },
    onError: (error) => {
      console.error("Error deleting Lora:", error);
    },
  });
};

export default useDeleteLora;